interface TablePagerProps {
  page: number;
  totalPages: number;
  total: number;
  shown: number;
  pageSize: number;
  label: string;
  note?: string;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
}

// Table footer used by the customer details tabs: "Showing 1–25 of 80" + rows + pager
const TablePager = ({ page, totalPages, total, shown, pageSize, label, note, setPage, setPageSize }: TablePagerProps) => {
  // Page numbers with gaps (1 … 4 5 6 … 20)
  const pageItems = (): (number | "gap")[] => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const out: (number | "gap")[] = [1];
    if (page > 3) out.push("gap");
    for (let p = Math.max(2, page - 1); p <= Math.min(totalPages - 1, page + 1); p++) out.push(p);
    if (page < totalPages - 2) out.push("gap");
    out.push(totalPages);
    return out;
  };

  const firstRow = total ? (page - 1) * pageSize + 1 : 0;
  const lastRow = total ? (page - 1) * pageSize + shown : 0;

  return (
    <div className="cx-tfoot">
      <span>Showing <b>{firstRow}–{lastRow}</b> of <b>{(total || 0).toLocaleString("en-IN")}</b> {label}</span>
      {note && <span>{note}</span>}
      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <span>Rows</span>
        <select className="cx-select" value={pageSize} onChange={(e) => { setPageSize(+e.target.value); setPage(1); }}>
          {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <div className="cx-pager">
          <button type="button" disabled={page <= 1} onClick={() => setPage(Math.max(1, page - 1))}>‹</button>
          {pageItems().map((p, idx) =>
            p === "gap" ? (
              <span key={`gap-${idx}`} className="gap">…</span>
            ) : (
              <button type="button" key={p} className={p === page ? "on" : ""} onClick={() => setPage(p)}>{p}</button>
            )
          )}
          <button type="button" disabled={page >= totalPages} onClick={() => setPage(Math.min(totalPages, page + 1))}>›</button>
        </div>
      </div>
    </div>
  );
};

export default TablePager;
